<template>
  <v-dialog v-model="data.dialogShow" fullscreen hide-overlay transition="dialog-bottom-transition">
    <v-card>
      <v-toolbar color="gray" class="elevation-1 green lighten-2">
        <v-btn flat icon @click="data.dialogShow = false">
          <font-awesome-icon icon="arrow-left" size="2x" class="black--text"/>
        </v-btn>
        <v-spacer></v-spacer>
        <v-toolbar-items></v-toolbar-items>
      </v-toolbar>
      <v-container fluid>
        <v-card class="mb-2 py-1 elevation-1 green lighten-5">
          <v-layout align-start justify-start row wrap>
            <v-flex md12>
              <v-btn color="light-blue darken-3" :loading="isLoading" @click="onSave()">
                <v-icon class="pr-2">save</v-icon>SAVE
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>
        <v-card class="mb-1 py-1 elevation-1 green lighten-5">
          <v-layout align-start justify-start row wrap>
            <v-flex md6>
              <v-alert
                class="ma-2"
                dismissible
                :value="alertValue"
                :color="alertColor"
                :icon="alertIcon"
                outline
              >{{alertMessage}}</v-alert>
            </v-flex>
          </v-layout>

          <v-layout align-start justify-start row wrap>
            <v-flex md4>
              <v-layout align-start justify-start row wrap>
                <v-flex md12 class="px-3">
                  <v-text-field
                    disabled
                    label="Kode"
                    v-model="data.code"
                    v-validate="'required'"
                    data-vv-name="code"
                    :error-messages="errors.collect('code')"
                  ></v-text-field>
                </v-flex>
                <v-flex md12 class="px-3">
                  <v-text-field label="Jumlah Pilihan" v-model="numberOfChoices" mask="###"></v-text-field>
                </v-flex>
                <v-flex md12 class="px-3">
                  <v-text-field label="Nomor Urut" v-model="sortNumber" mask="###"></v-text-field>
                </v-flex>
                <v-flex md12 class="px-3">
                  <span class="body-2">Status :</span>
                  <v-switch label="Enable" v-model="isEnabled"></v-switch>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex md6>
               <v-flex md12>
                <table>
                  <tr>
                    <td>
                      <v-text-field
                        style="margin:0;padding:0;width:100px;padding-right:15px;"
                        label="Answer"
                        v-model="answer"
                      ></v-text-field>
                    </td>
                    <td>
                      <v-text-field
                        style="margin:0;padding:0;width:100px;padding-right:15px;"
                        label="Point"
                        v-model="point"
                        mask="###"
                      ></v-text-field>
                    </td>
                    <td>
                      <v-btn small color="warning" @click="onAddAnswer()">
                        <font-awesome-icon icon="plus" class="black--text"/>&nbsp;&nbsp;
                        <span class="black--text">Add</span>
                      </v-btn>
                    </td>
                  </tr>
                </table>
                <table>
                  <tr v-for="(row,index) in answers" v-bind:key="row.key">
                    <td>
                      <span class="body-2 pr-2">{{row.key}}</span>
                    </td>
                    <td>
                      <span class="body-2">: {{row.point}}</span>
                    </td>
                    <td>
                      <span style="cursor: pointer;" @click="onRemoveAnswer(index)">
                        <font-awesome-icon icon="times" class="red--text text--darken-4 ml-3"/>
                      </span>
                    </td>
                  </tr>
                </table>
              </v-flex>
              <v-flex md12>
                <span class="body-2">Pembahasan :</span>
                <quill-editor class="mt-2" :options="editorOption" v-model="pembahasan"></quill-editor>
              </v-flex>
            </v-flex>
          </v-layout>
          <v-layout align-start justify-start row wrap>
            <v-flex md12 class="px-2">
              <quill-editor :options="editorOption" v-model="question"></quill-editor>
            </v-flex>
          </v-layout>
        </v-card>
      </v-container>
    </v-card>
  </v-dialog>
</template>
<script>
import { quillEditor } from "vue-quill-editor";
import ApiService from "@/common/api.service";

export default {
  components: {
    quillEditor
  },
  props: {
    data: Object
  },
  data: () => ({
    answers: [],
    isLoading: false,
    alertColor: "",
    alertIcon: "",
    alertValue: false,
    alertMessage: "",
    answer: "",
    point: "",
    isEnabled: true,
    sortNumber: 0,
    pembahasan: "",
    question: "",
    numberOfChoices: 0,
    editorOption: {
      modules: {
        toolbar: [
          ["bold", "italic", "underline", "strike"],
          ["blockquote", "code-block"],
          [
            {
              header: 1
            },
            {
              header: 2
            }
          ],
          [
            {
              list: "ordered"
            },
            {
              list: "bullet"
            }
          ],
          [
            {
              script: "sub"
            },
            {
              script: "super"
            }
          ],
          [
            {
              indent: "-1"
            },
            {
              indent: "+1"
            }
          ],
          [
            {
              direction: "rtl"
            }
          ],
          [
            {
              size: ["small", false, "large", "huge"]
            }
          ],
          [
            {
              header: [1, 2, 3, 4, 5, 6, false]
            }
          ],
          [
            {
              font: []
            }
          ],
          [
            {
              color: []
            },
            {
              background: []
            }
          ],
          [
            {
              align: []
            }
          ],
          ["clean"],
          ["link", "image", "video"]
        ],
        history: {
          delay: 1000,
          maxStack: 50,
          userOnly: false
        }
      }
    }
  }),
  updated() {
    
    if (this.data.firstLoad === true) {      
      const vm = this;
      ApiService.post("DataSubAspec/GetDataQuestionById", {
        Id: vm.data.id
      })
        .then(response => {
          vm.numberOfChoices = response.data.numberOfChoices;
          vm.answers = response.data.dataQuestionAnswer;
          vm.answer = response.data.answer;
          vm.point = response.data.point;
          vm.isEnabled = response.data.isEnabled;
          vm.sortNumber = response.data.sn;
          vm.pembahasan = response.data.pembahasan;
          vm.question = response.data.question;
          vm.data.firstLoad = false;
        })
        .catch(() => {
          vm.data.firstLoad = false;
        });
    }
  },
  methods: {
    onRemoveAnswer: function(rowIndex) {
      this.answers.splice(rowIndex, 1);
    },
    onAddAnswer: function() {
      const vm = this;
      if (this.answer === "" || this.point === "") {
        return;
      }

      let isExist = false;

      this.answers.forEach(function(entry) {
        if (entry.key === vm.answer) {
          isExist = true;
        }
      });

      if (isExist) return;

      this.answers.push({ key: this.answer, point: this.point });
      this.answer = "";
      this.point = "";
    },
    onSave: function() {
      this.$validator.validate().then(valid => {
        if (valid) {          
          const vm = this;
          vm.isLoading = true;
          ApiService.post("DataSubAspec/UpdateDataSubAspecQuestion", {                        
            IsEnabled: vm.isEnabled,
            SortNumber: vm.sortNumber,
            Pembahasan: vm.pembahasan,
            Question: vm.question,
            Answers: vm.answers,
            NumberOfChoices: vm.numberOfChoices,
            Id: vm.data.id
          })
            .then(() => {
              vm.isLoading = false;
              vm.$emit("close-window");

              vm.data.dialogShow = false;
            })
            .catch(({ response }) => {
              vm.isLoading = false;
              if (response.status == 400) {
                vm.alertColor = "warning";
                vm.alertIcon = "priority_high";
                vm.alertValue = true;
                vm.alertMessage = response.data;
              } else {
                vm.alertColor = "error";
                vm.alertIcon = "warning";
                vm.alertValue = true;
                vm.alertMessage = response.data;
              }
            });
        }
      });
    },
    clearForm: function() {
      this.isLoading = false;
      this.alertColor = "";
      this.alertIcon = "";
      this.alertValue = false;
      this.alertMessage = "";
      this.$validator.reset();
    }
  }
};
</script>
